export default __webpack_public_path__ + "static/media/Corsairs-treasure-04.a35d4dc4.png";